module.exports = __webpack_public_path__ + "img/sdg11_jp.90806803.png";